
import { Options, Vue } from 'vue-class-component';
import { ElectricityEmissionClient, FootwearEstimationClient, RawMaterialClient } from '@/services/Services';
import MaterialCompositionSummary from '@/views/calculator/components/materialCompositionSummary.vue';
import EditMaterialCompositionModal from '@/views/calculator/modals/editMaterialCompositionModal.vue';
import { openMacroCompositionModal } from '@/views/calculator/components/macroCompositionFill';
import * as OM from '@/Model';
import * as VM from '@/viewModel';
import store from '@/store';

@Options({
    components: {
        MaterialCompositionSummary
    }
})
export default class ComponentsMaterial extends Vue {

    estimationIdentifier: string = "";

    footwearData: OM.FootwearData = new OM.FootwearData();
    footwearComposition: OM.SelectedComposition = new OM.SelectedComposition();

    allCountries: OM.TextIdentifier[] = [];
    availableMaterials: OM.RawMaterialConfigurationVM[] = [];

    loaded: boolean = false;

    created() {
        this.estimationIdentifier = this.$route.params.estimationIdentifier.toString();
        this.init();
    }

    init() {
        Promise.all([
            FootwearEstimationClient.getEstimationFootwearData(this.estimationIdentifier),
            ElectricityEmissionClient.getCountries(false)
        ])
        .then(xs => {
            this.footwearData = xs[0];
            this.allCountries = xs[1];

            Promise.all([
                FootwearEstimationClient.getFootwearComposition(this.footwearData.garment.identifier, this.estimationIdentifier, false, false),
                RawMaterialClient.getAllAvailableMaterialsForGarment(this.footwearData.garment.identifier, this.footwearData.processType)
            ])
            .then(ys => {
                this.footwearComposition = ys[0];
                this.availableMaterials = ys[1];

                setTimeout(() => {
                    this.loaded = true;
                }, 100);
            })
        })
    }

    get isReadOnly() {
        return store.state.loggedUser.role == VM.Roles.ReadOnly;
    }

    // The counter next to Continue and the Continue gate are the same question, so they are the same
    // computation. A second getter would eventually disagree with this one.
    get pendingCount() {
        return this.footwearComposition.percentageCompositionValues
            .filter(x => x.parentName != "")
            .filter(x => !x.materialsAssigned)
            .length;
    }

    get isDisabled() {
        return this.pendingCount > 0;
    }

    openMaterialsModal(row: OM.PercentageCompositionValues) {
        this.$opModal.show(EditMaterialCompositionModal, {
            elementName: row.name,
            availableMaterials: this.availableMaterials,
            allCountries: this.allCountries,
            initialMaterials: row.selectedMaterials,
            initialCountryIdentifier: row.selectedCountry != null ? row.selectedCountry.identifier : "",
            initialNoMaterial: row.materialsAssigned && row.selectedMaterials.length == 0,
            isReadOnly: this.isReadOnly,
            saveCallback: (payload) => {
                let model = new OM.UpdateMaterialCompositionVM();
                model.identifier = this.estimationIdentifier;
                model.name = row.name;
                model.noMaterial = payload.noMaterial;
                model.materials = payload.noMaterial ? [] : payload.materials;
                model.selectedCountry = payload.noMaterial
                    ? new OM.TextIdentifier()
                    : this.allCountries.filter(x => x.identifier == payload.countryIdentifier)[0];

                return FootwearEstimationClient.updateMaterialComposition(model)
                .then(() => {
                    this.$opModal.closeLast();
                    this.init();
                })
            }
        })
    }

    openMacroModal(macro: OM.PercentageCompositionValues) {
        openMacroCompositionModal(this.$opModal, {
            macro: macro,
            children: this.footwearComposition.percentageCompositionValues.filter(x => x.parentName == macro.name),
            availableMaterials: this.availableMaterials,
            allCountries: this.allCountries,
            isReadOnly: this.isReadOnly,
            estimationIdentifier: this.estimationIdentifier,
            save: model => FootwearEstimationClient.updateMacroMaterialComposition(model),
            onSaved: () => this.init()
        })
    }
}
